export default {
    "table": {
        "moduletype": "table",
        "pagination": true,
        "name": "事务错误中心",
        "items": [ 
            { 
                "itemtype": "label",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "错误原因",
                "disabled": true,
                "attrcode": "billmaker" 
            },
            { 
                "itemtype": "customer",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "发起方单据号",
                "disabled": true,
                "attrcode": "billmaker1"
            },
            { 
                "itemtype": "label",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "单据类型",
                "disabled": true,
                "attrcode": "billmaker2" 
            },
            { 
                "itemtype": "label",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "交易类型",
                "disabled": true,
                "attrcode": "billmaker3" 
            },
            { 
                "itemtype": "label",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "操作类型",
                "disabled": true,
                "attrcode": "billmaker4" 
            },
            { 
                "itemtype": "label",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "业务日期",
                "disabled": true,
                "attrcode": "billmaker5" 
            },
            { 
                "itemtype": "customer",
                "maxlength": "20",
                "visible": true,
                "width": "200px",
                "label": "操作",
                "disabled": true,
                "attrcode": "opr",
                "className": "table-opr",
                "fixed": "right"
            }
        ] 
    }  
};